import request from '../request';

export function getBranches(params) {
  return request({
    url: 'directories/branches',
    method: 'get',
    params,
  });
}

export function getPageBranch(id) {
  return request({
    url: `directories/branches?page=${id}`,
    method: "get",
  });
}

export function getBranchID(id) {
  return request({
    url: `directories/branches/${id}`,
    method: "get",
  });
}

export function postBranches(data) {
  return request({
    url: 'directories/branches',
    method: 'post',
    data,
  });
}

export function putBranch(data) {
  return request({
    url: `directories/branches/${data.get("id")}`,
    method: "post",
    data,
  })
}

export function deleteBranch(data) {
  return request({
    url: `directories/branches/${data}`,
    method: 'delete',
    data,
  })
}